import { render, staticRenderFns } from "./therm-list-header.vue?vue&type=template&id=54da4730&scoped=true"
import script from "./therm-list-header.vue?vue&type=script&lang=js"
export * from "./therm-list-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54da4730",
  null
  
)

export default component.exports